import { Link } from 'react-router-dom';

export default function BrokerSideBar() {
    return (
        <div className="app-menu navbar-menu">
            {/* LOGO */}
            <div className="navbar-brand-box">
                {/* Dark Logo*/}
                <Link to={"/"} className="logo logo-dark">
                    <span className="logo-sm">
                        <img src="/assets/images/logo3d.jpg" alt height={22} />
                    </span>
                    <span className="logo-lg">
                        <img src="/assets/images/logo3d.jpg" alt height={17} />
                    </span>
                </Link>
                {/* Light Logo*/}
                <Link to={"/"} className="logo logo-light">
                    <span className="logo-sm">
                        <img src="/assets/images/logo3d.jpg" alt height={22} />
                    </span>
                    <span className="logo-lg">
                        <img src="/assets/images/logo3d.jpg" alt height={17} />
                    </span>
                </Link>
                <button type="button" className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover" id="vertical-hover">
                    <i className="ri-record-circle-line" />
                </button>
            </div>
            <div id="scrollbar">
                <div className="container-fluid">
                    <div id="two-column-menu">
                    </div>
                    <ul className="navbar-nav" id="navbar-nav">
                        <li className="menu-title"><span data-key="t-menu">Menu</span></li>
                        {
                            localStorage.getItem('roleName') === "BROKER" ?
                                <>
                                    <li className="nav-item">
                                        <Link className="nav-link menu-link" to={"/broker/dashboard"}>
                                            <i className="mdi mdi-speedometer" /> <span data-key="t-dashboards">Dashboard</span>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link menu-link" to={"/userdashboard/upload"}>
                                            <i className="mdi mdi-form-select" /> <span data-key="t-dashboards">New Application</span>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link menu-link" to={"/broker/applications"}>
                                            <i className="mdi mdi-account" /> <span data-key="t-dashboards">Leads</span>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link menu-link" href="#settings" data-bs-toggle="collapse" role="button" aria-expanded="false" aria-controls="settings">
                                            <i className="mdi mdi-cog" /> <span data-key="t-settings">Settings</span>
                                        </Link>
                                        <div className="collapse menu-dropdown" id="settings">
                                            <ul className="nav nav-sm flex-column">
                                                <li className="nav-item">
                                                    <Link to={"/userdashboard/profile"} className="nav-link" data-key="t-crm"> My Profile </Link>
                                                </li>
                                                <li className="nav-item">
                                                    <Link to={"/userdashboard/usercredits"} className="nav-link" data-key="t-crm"> Credits History </Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </li>
                                </>
                                : ""}
                    </ul>
                </div>
                {/* Sidebar */}
            </div>
        </div>
    );
}
